<template>
    <div class="monobank-refusal">
        <DefTitle :result="1" :center="screenWidth >= 768">
            <h1>
                <span>{{ messages.error }}</span>
            </h1>
        </DefTitle>
         <div class="monobank-refusal__block">
             <svg class="monobank-refusal__icon">
                 <use xlink:href="#svg-sad-smile"></use>
             </svg>
             <p class="monobank-refusal__text">
                 {{ getPayData.error }}
             </p>
             <DefButtonPrimary
                @click="commit('thanks/removeMonobankError')"
             >
                 <span>
                     {{ messages.backToOrder }}
                 </span>
             </DefButtonPrimary>
         </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import DefProgramMe from "../../def/DefProgramMe/DefProgramMe";
import DefTitle from "../../def/DefTitle/DefTitle";
import DefButtonPrimary from "../../def/DefButtonPrimary/DefButtonPrimary";
const {
    state: {
        thanks: {
            data: {
                order : {
                    messages
                }
            }
        }
    },
    commit,
    getters: {
        'thanks/getPayData': getPayData,
    },
} = useStore();
</script>

<script>
export default {
    name: 'MonobankRefusal',
}
</script>

<style lang="scss" scoped>
.monobank-refusal{
    margin-bottom: 64px;
    @include point-lg{
        margin-bottom: 80px;
    }
    &__block{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px 16px;
        text-align: center;
        background-color: #F6F6F6;
        border: 1px solid var(--border-colour-primary);
        @include point-md{
            padding: 48px 24px;
        }
    }
    &__icon{
        margin-bottom: 36px;
        width: 40px;
        height: 40px;
        @include point-md{
            margin-bottom: 34px;
            width: 64px;
            height: 64px;
        }
    }
    &__text{
        font-weight: 500;
        font-size: rem(18);
        line-height: 135%;
        margin-bottom: 24px;
        @include point-lg{
            margin-bottom: 32px;
        }
    }
}
</style>